module.exports = __webpack_public_path__ + "img/Microsoft-Entra-ID-logo.1c49030d.png";